import { ColorType } from "arkh";

export function colorForNumber(
  val: number | null,
  lessThan: number | null,
  greaterThan: number | null
): ColorType {
  if (val === null) {
    return "darkerText";
  }
  if (lessThan !== null && val > lessThan) {
    return "negative";
  }
  if (greaterThan !== null && val < greaterThan) {
    return "negative";
  }
  if (lessThan !== null || greaterThan !== null) {
    return "positive";
  }
  return "darkerText";
}
